// Lazy Load All Images on Product Page
document.addEventListener("DOMContentLoaded", function() {
  // Select all div elements with the specified class
  var swatchDivs = document.querySelectorAll('.swatch-image.swatch-group-selector');

  // Set up a single observer to lazy load all background images
  var observer = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
          if (entry.isIntersecting) {
              var lazyImageDiv = entry.target;
              var realImageUrl = lazyImageDiv.getAttribute('data-bg');
              lazyImageDiv.style.backgroundImage = 'url(' + realImageUrl + ')';
              observer.unobserve(lazyImageDiv);
          }
      });
  });

  // Loop through each div to prepare for lazy loading
  swatchDivs.forEach(function(swatchDiv) {
      // Get the background image URL from the inline style
      var starSetImage = swatchDiv.querySelector('.star-set-image');
      if (!starSetImage) return;

      var backgroundImageUrl = starSetImage.style.backgroundImage;

      // Extract the actual URL from the backgroundImageUrl string
      var imageUrl = backgroundImageUrl.slice(5, -2); // Remove 'url("' at the start and '")' at the end

      // Replace the background image with a placeholder and set a data attribute with the original image URL
      starSetImage.style.backgroundImage = 'none';
      starSetImage.setAttribute('data-bg', imageUrl);

      // Observe the element
      observer.observe(starSetImage);
  });
}); 